import { render, staticRenderFns } from "./LoginTransfer.vue?vue&type=template&id=4cb69374&scoped=true&"
import script from "./LoginTransfer.vue?vue&type=script&lang=js&"
export * from "./LoginTransfer.vue?vue&type=script&lang=js&"
import style0 from "./LoginTransfer.vue?vue&type=style&index=0&id=4cb69374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb69374",
  null
  
)

export default component.exports